export const config = {
  title: 'A Force of Nature Tree Service | Expert Tree Removal & Care in North Fort Myers, FL',
  meta: {
    description:
      'A Force of Nature Tree Service provides professional tree removal, trimming, and storm cleanup in North Fort Myers, FL. Licensed, insured, and trusted for safe and affordable tree care.',
    keywords: [
      'Tree Service North Fort Myers',
      'Tree Removal',
      'Tree Trimming',
      'Stump Grinding',
      'Emergency Tree Services',
      'Storm Cleanup',
      'Tree Care Experts',
      'A Force of Nature Tree Service',
    ],
    author: 'A Force of Nature Tree Service',
    canonicalUrl: 'https://aforceofnaturetreeservice.com/',
  },
  sections: {
    header: {
      businessName: 'A Force of Nature Tree Service',
    },
    sectionB: {
      heroTitle: 'A Force of Nature Tree Service',
      heroSubtitle: 'Professional Tree Services in North Fort Myers, FL',
      learnAboutText: 'Learn About Our Tree Services',
      phoneNumber: '2398412179',
      phoneLabel: '(239) 841-2179',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1176788229/photo/tree-surgeon-using-chainsaw-to-cut-tree-branch-tied-up-with-rope.jpg?s=612x612&w=0&k=20&c=61v1ZkO3VsS1_ZX8VNFyOGoR8PyiwUk8w8VFRoVTBT4=',
      cardData: [
        {
          title: 'Tree Removal',
          description:
            'Safe and efficient tree removal by certified experts, ensuring your property stays protected.',
        },
        {
          title: 'Tree Trimming & Pruning',
          description:
            'Maintain tree health and improve appearance with our professional trimming services.',
        },
        {
          title: 'Emergency Storm Cleanup',
          description:
            'Fast response for fallen trees and debris cleanup after storms—available 24/7.',
        },
      ],
      description:
        'A Force of Nature Tree Service offers expert tree removal, trimming, pruning, and storm cleanup in North Fort Myers, FL. We’re fully licensed, insured, and committed to safe, reliable, and affordable services.',
    },
    sectionC: {
      servicesTitle: 'Our Tree Services',
      servicesDescription:
        'Explore our range of professional tree care services tailored to protect your property and enhance your landscape.',
      cards: [
        {
          title: 'Tree Removal',
          description:
            'We specialize in safe and efficient tree removal for residential and commercial properties.',
          imageSrc: 'https://aforceofnaturetreeservice.com/wp-content/uploads/2025/03/Tree-Removal-4.jpg',
          imageAlt: 'Tree Removal Service',
        },
        {
          title: 'Trimming & Pruning',
          description:
            'Keep your trees healthy and well-shaped with expert trimming and pruning services.',
          imageSrc: 'https://aforceofnaturetreeservice.com/wp-content/uploads/2023/11/Why-Cabling-is-Essential-for-Tree-Health-and-Safety.jpg',
          imageAlt: 'Tree Trimming',
        },
        {
          title: 'Stump Grinding',
          description:
            'Remove unsightly stumps from your yard with our precision grinding services.',
          imageSrc: 'https://aforceofnaturetreeservice.com/wp-content/uploads/2025/03/Stump-Removal-5.jpg',
          imageAlt: 'Stump Grinding',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        '24/7 Emergency Tree Services',
        'Storm Damage Cleanup',
        'Palm Tree Trimming',
        'Land Clearing',
        'Debris Hauling',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://aforceofnaturetreeservice.com/wp-content/uploads/2023/11/How-Professional-Tree-Removal-Can-Protect-Your-Property.jpg',
        alt: 'A Force of Nature Tree Service Team',
      },
      aboutText: [
        'A Force of Nature Tree Service is a locally owned and operated business proudly serving North Fort Myers and surrounding areas.',
        'With years of experience and a passion for tree care, we handle everything from large tree removals to emergency storm services. Fully licensed and insured, we prioritize safety, customer satisfaction, and affordable pricing.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'A Force of Nature Tree Service Logo',
      businessName: 'A Force of Nature Tree Service',
      contact: {
        phone: '2398412179',
        phoneLabel: '(239) 841-2179',
        email: 'info@aforceofnaturetreeservice.com',
        website: 'https://aforceofnaturetreeservice.com/',
        address: 'Northside Cir, North Fort Myers, FL 33903, United States',
      },
      socialMedia: {
        facebook: 'https://www.facebook.com/AFONTSLLC/',
        instagram: 'https://www.instagram.com/aforceofnaturetreeservice/',
        linkedin: null,
        twitter: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Northside Cir, North Fort Myers, FL 33903, United States',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3526.5352501452685!2d-81.89645638494027!3d26.69831108323459!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88db1c7df8e3cd07%3A0xf0e6ba678bca0155!2sNorthside%20Cir%2C%20North%20Fort%20Myers%2C%20FL%2033903!5e0!3m2!1sen!2sus!4v1712068000000!5m2!1sen!2sus',
    },
  },
};

export default config;
